export const royaltyPayorKinds = [
  "pro",
  "publisher",
  "other",
  "digital_distributor",
  "custom",
  "label",
] as const;

export const usernameOrEmailChoices = ["email", "username"] as const;

export const ADMINMP = "admin_mp";
export const ASCAP = "ascap";
export const BMI = "bmi";
export const SESAC = "sesac";
export const SONY = "sony_atv";

export const ASCAP_DESIGNATED_USER_INSTRUCTION_URL =
  "https://royx.s3.amazonaws.com/ASCAP_Designated_User_Instructions_2021.pdf";

export const permissionCodeNames = [
  "get_credentials",
  "get_offer",
  "get_outreach",
  "get_valuation",
] as const;

export const distributionFrequencyChoices = [
  "month",
  "quarter",
  "semester",
  "year",
] as const;

export const DISTRIBUTION_FREQUENCY_PERIOD_CLASSES_MAP: Record<
  typeof distributionFrequencyChoices[number],
  number
> = {
  month: 12,
  quarter: 4,
  semester: 2,
  year: 1,
};
